// IMPORTACIÓN DE PAQUETE
import firebase from "firebase/compat/app";

// REQUERIMIENTOS
require("firebase/compat/auth");
require("firebase/compat/firestore");
require("firebase/compat/storage");
require("firebase/compat/functions");
require("firebase/compat/analytics");

// FIREBASE APP CONFIGURACIÓN
firebase.initializeApp({
  apiKey: "AIzaSyBpG-6a5mo_YEhC-tnOw7J6UoSsxsU_598",
  authDomain: "pef-by-sofu.firebaseapp.com",
  databaseURL: "https://pef-by-sofu.firebaseio.com",
  projectId: "pef-by-sofu",
  storageBucket: "pef-by-sofu.appspot.com",
  messagingSenderId: "878189126801",
  appId: "1:878189126801:web:51c05f699fc74e822d4b30",
  measurementId: "G-32S6J9DYHP",
});

firebase.analytics();

// PARÁMETROS
const auth = firebase.auth();
const db = firebase.firestore();
const storage = firebase.storage();
const functions = firebase.functions();

// EXPORTACIÓN DE PARÁMETROS
export { firebase, auth, db, storage, functions };
